import React, { useEffect, useState } from "react";

const TermsAndServices = () => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    fetch("/PolicyPage/termsAndCondition.txt")
      .then((response) => response.text())
      .then((data) => setHtmlContent(data))
      .catch((error) => console.error("Error loading HTML file:", error));
  }, []);

  return <div className="py-12" dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default TermsAndServices;
